export const columns = [
  {
    title: 'page_tenant_operation',
    key: 'action',
    fixed: 'left',
    width: 90,
    scopedSlots: { customRender: 'action' }
  },
  {
    title: 'page_user_management_login_account',
    dataIndex: 'account',
    key: 'account',
    ellipsis: true,
    width: 209,
    scopedSlots: { customRender: 'account' }
  },
  {
    title: 'page_user_management_user_nickname',
    dataIndex: 'name',
    key: 'name',
    ellipsis: true,
    width: 209
  },
  {
    title: 'page_user_management_user_name',
    dataIndex: 'realName',
    key: 'realName',
    ellipsis: true,
    width: 209
  },
  {
    title: 'page_user_management_subordinate_role',
    dataIndex: 'roleName',
    key: 'roleName',
    ellipsis: true,
    width: 210
  },
  {
    title: 'page_ops_customer_data_permissions',
    dataIndex: 'deptName',
    key: 'deptName',
    ellipsis: true,
    width: 231,
    scopedSlots: { customRender: 'deptName' }
  },
  {
    title: 'page_user_management_phone_number',
    dataIndex: 'phone',
    key: 'phone',
    ellipsis: true,
    width: 231
  },
  {
    title: 'page_user_management_mail_box',
    dataIndex: 'email',
    key: 'email',
    ellipsis: true,
    width: 230
  },
  {
    title: 'page_user_management_user_gender',
    dataIndex: 'sex',
    key: 'sex',
    width: 100,
    scopedSlots: { customRender: 'sex' }
  },
]
